


<div id="lesson">
    <div class="container-fluid">
        <div class="row">
            
            <div class="col-md-3" *ngIf="showSideMenu">
                <nav id="secondary-navigation">
                    <!-- Header -->
                    <header class="header">
                        <h5>FDP's</h5>
                    </header>
                    <!-- /Header -->
                    <ul>
                        <li routerLinkActive="active">
                            <a routerLink="/research/fdps/2023-2024" (click)="checkRoute()">2023-2024</a>
                        </li>
                        <li routerLinkActive="active">
                            <a routerLink="/research/fdps/2019-2020" (click)="checkRoute()">2019-2020</a>
                        </li>
                       
                    </ul>
                </nav>
            </div>
            <div [ngClass]="fullWidth ? 'col-md-12' : 'col-md-9'">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
  </div>